<template>

    <div>

        <div :id="id+'-struct'" class="trax-collapse">
            <div class="card-collapse clearfix" v-for="(domainName, typeCode) in competency_domains_names" :key="typeCode" v-if="visibleCompetency(typeCode)">

                <button :class="'btn-'+competencyColor(typeCode)+' btn btn-link btn-just-icon float-left mt-2'" @click="openCompetencies(typeCode)" v-if="!editDisabled">
                    <i class="material-icons">edit</i>
                </button>

                <div :class="headerClass">

                    <div class="float-left pr-2" v-if="states[typeCode]">
                        <i class="material-icons text-danger" style="font-size:24px" v-if="states[typeCode].level == 1">error</i>
                        <i class="material-icons text-warning" style="font-size:24px" v-if="states[typeCode].level == 2">error</i>
                        <i class="material-icons text-success" style="font-size:24px" v-if="states[typeCode].level == 3">check_circle</i>
                    </div>

                    <a :href="'#'+id+'-struct-'+typeCode" :aria-expanded="expanded" data-toggle="collapse" class="collapsed">
                        <i class="material-icons">keyboard_arrow_down</i>
                        <h5 class="mb-1">{{ domainName }}</h5>
                    </a>
                </div>

                <div :id="id+'-struct-'+typeCode" :class="bodyClass" class="competency-collapsable" v-if="states[typeCode]">

                    <div class="trax-text-small mb-2" v-for="(item, index) in states[typeCode].indicators" :key="index" v-if="states[typeCode].indicators && item">
                        <i class="material-icons text-danger float-left" v-if="item == 1">error_outline</i> 
                        <i class="material-icons text-success float-left" v-if="item == 3">check</i> 
                        <p class="pl-4" style="white-space:pre-wrap;">{{ indicators ? indicators[index] : '' }}</p>
                    </div>

                    <div class="" v-if="states[typeCode].comments">
                        <i class="material-icons">format_quote</i> 
                        <span style="font-style:italic;color:#999;white-space:pre-wrap;">{{ states[typeCode].comments }}</span>
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-flight-follow-up-learner-edit-competencies'},
            parentId: null,
            states: null,
            indicators: null,
            editDisabled: null,
            mandatoryCompetencies: null,
            bus: null
        },

        data: function() {
            return {
                competency_domains_names: data.competency_domains_names,
            }
        },

        computed: {

            headerClass: function() {
                var res = 'card-header pt-3';
                if (!this.editDisabled) res += ' ml-5';
                return res;
            },

            expanded: function() {
                return this.editDisabled ? 'true' : 'false';
            },

            bodyClass: function() {
                var res = 'card-body collapse pt-3 pl-2';
                if (this.editDisabled) res += ' show';
                else res += ' ml-5';
                return res;
            }
        },

        created: function() {
            var that = this;
            this.bus.$on(this.id+'-view-force-update', function() {
                that.$forceUpdate();
            });
            this.bus.$on(this.parentId+'-expand-competencies', this.expandCompetencies);
            this.bus.$on(this.parentId+'-collapse-competencies', this.collapseCompetencies);
        },

        methods: {

            expandCompetencies() {
                $('.competency-collapsable').collapse('show');
            },

            collapseCompetencies() {
                $('.competency-collapsable').collapse('hide');
            },

            mandatoryCompetency(typeCode) {
                return this.mandatoryCompetencies && this.mandatoryCompetencies.includes(typeCode);
            },

            competencyColor(typeCode) {
                return this.mandatoryCompetency(typeCode) ? 'danger' : 'default';
            },

            visibleCompetency(typeCode) {
                return !this.editDisabled || (this.states[typeCode] && (
                    this.states[typeCode].level 
                    || (this.states[typeCode].comments && this.states[typeCode].comments.trim() != '')
                    || (this.states[typeCode].indicators && Object.keys(this.states[typeCode].indicators).length)
                ));
            },

            openCompetencies(typeCode) {
                var states = this.states[typeCode] ? this.states[typeCode] : {indicators: {}};
                this.bus.$emit(this.id+'-select-open', {
                    title: this.competency_domains_names[typeCode],
                    data: {type_code: typeCode, states: states }
                });
            }
        }

    }
</script>
